import { HttpClient } from "@angular/common/http";
import { Injectable, OnDestroy } from "@angular/core";
import { Store } from "@ngrx/store";
import { Observable, Subscription } from "rxjs";
import { tap } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { AppSettings } from "src/components/shared-components/class/general-classes/app-settings";
import { ApiVersion } from "src/model/interface/api-version";
import { AppConfiguration } from "src/model/interface/app-configuration";
import {
  clientSettingsSetApplicationThemeAction,
  clientSettingsSetDigitalPlaceFlagAction,
} from "src/state/actions/client-settings.actions";
import { LogLevel } from "src/components/shared-components/enum/enumLog";
import { LoggerService } from "./logger.service";

@Injectable({
  providedIn: "root",
})
export class UtilityService implements OnDestroy {
  private _logContext: string = "Utility.service";

  private _translateSubscription: Subscription = null;

  _eventSubscriptions: Array<Subscription> = null;

  constructor(
    private _http: HttpClient,
    private _store: Store,
    private _loggerService: LoggerService
  ) { }

  ngOnDestroy() {
    if (this._translateSubscription) {
      this._translateSubscription.unsubscribe();
    }
  }

  /**
   * Get software API version from serve
   *
   * @returns
   */
  public getSoftwareServerVersion(): Promise<ApiVersion> {
    return this._http
      .get<ApiVersion>(environment.httpServerRoot + AppSettings.API_URL_VERSION)
      .pipe(tap((addresses: ApiVersion) => { }))
      .toPromise();
  }

  /**
   * Check if input string is json
   *
   * @param inputString test json string
   */
  public isJson(inputString: string): boolean {
    let parsedJson = null;
    let isJson: boolean = false;

    try {
      parsedJson = JSON.parse(inputString);

      if (typeof parsedJson === "object" && parsedJson !== null) {
        isJson = true;
      }
    } catch {
      isJson = false;
    }

    return isJson;
  }

  

  /**
   * Get blob image from url
   *
   * @param url Url to get image
   * @param username Username for basic auth
   * @param password Password for basic auth
   *
   * @returns
   */
  public async getBlobImage(
    url: string,
    username: string,
    password: string
  ): Promise<any> {
    return await this._http
      .post(environment.httpServerRoot + AppSettings.API_URL_MEDIA + "/blob", {
        uri: url,
        username,
        password,
      })
      .toPromise();
  }

  /**
   * Take a string in the form instanceguid_address and returns the two parts
   * @param InstanceGUID_Address
   * @returns an array where in position 0 there is the instanceguid and in position 1 the address
   */
  public AddressSplit(InstanceGUID_Address: string): string[] {
    let result: string[] = [];

    const splitted = InstanceGUID_Address.split("_");
    if (splitted.length >= 2) {
      result[0] = splitted[0];
      result[1] = splitted.slice(1, splitted.length).join("_");
    }

    return result;
  }

  /**
   * Generic generic UUID
   *
   * @returns
   */
  public generateUUID(): string {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  }
}
